import { defineMessages } from 'react-intl'

export default defineMessages({
  select: {
    id: 'genre.select',
    defaultMessage: 'Please select genre',
  },
  alternative: {
    id: 'genre.alternative',
    defaultMessage: 'Alternative & Indie Rock',
  },
  animation: {
    id: 'genre.animation',
    defaultMessage: 'Animation',
  },
  blues: {
    id: 'genre.blues',
    defaultMessage: 'Blues',
  },
  classics: {
    id: 'genre.classics',
    defaultMessage: 'Classics',
  },
  dance: {
    id: 'genre.dance',
    defaultMessage: 'Dance',
  },
  djmix: {
    id: 'genre.djmix',
    defaultMessage: 'DJ mix / Live set',
  },
  electronic: {
    id: 'genre.electronic',
    defaultMessage: 'Electronic',
  },
  family: {
    id: 'genre.family',
    defaultMessage: 'Family',
  },
  folk: {
    id: 'genre.folk',
    defaultMessage: 'Folk',
  },
  hiphop: {
    id: 'genre.hiphop',
    defaultMessage: 'Hiphop / Rap',
  },
  jazz: {
    id: 'genre.jazz',
    defaultMessage: 'Jazz',
  },
  metal: {
    id: 'genre.metal',
    defaultMessage: 'Metal',
  },
  pop: {
    id: 'genre.pop',
    defaultMessage: 'Pop',
  },
  rb: {
    id: 'genre.rb',
    defaultMessage: 'R&B',
  },
  reggae: {
    id: 'genre.reggae',
    defaultMessage: 'Reggae',
  },
  rock: {
    id: 'genre.rock',
    defaultMessage: 'Rock',
  },
  soundtracks: {
    id: 'genre.soundtracks',
    defaultMessage: 'Soundtracks',
  },
  world: {
    id: 'genre.world',
    defaultMessage: 'World Music',
  },
})
